import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import type { ColumnType } from 'antd/es/table';

import { DragButton } from '@/shared/components';

import type { IAdvantageItemData } from './types';

export const getColumnsData = ({
  setItemToOperate,
  openEditAdvantageModal,
  openDeleteAdvantageModal,
}: {
  setItemToOperate: (data: IAdvantageItemData | null) => void;
  openEditAdvantageModal: VoidFunction;
  openDeleteAdvantageModal: VoidFunction;
}) =>
  [
    {
      title: 'Заголовок',
      dataIndex: 'title',
      key: 'title',
      width: `35%`,
      ellipsis: true,
    },
    {
      title: 'Описание',
      dataIndex: 'description',
      key: 'description',
      width: `45%`,
      ellipsis: true,
    },
    {
      title: 'Иконка',
      dataIndex: 'iconType',
      key: 'iconType',
      width: 122,
      render: (_, { icon }) => (
        <img
          src={`/images/mainPageAdvantageIcons/${icon}.svg`}
          width={30}
          height={30}
          alt="Один из возможных логотипов преимущества"
        />
      ),
    },
    {
      title: '',
      dataIndex: 'options',
      key: 'options',
      width: 216,
      render: (_, { id, title, description, icon, position }) => (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <DragButton rowKey={position} />
          <Button
            onClick={(event) => {
              event.stopPropagation();

              setItemToOperate({ id, title, description, icon, position });
              openEditAdvantageModal();
            }}
          >
            <EditOutlined style={{ fontSize: '20px' }} />
          </Button>
          <Button
            onClick={(event) => {
              event.stopPropagation();

              setItemToOperate({ id, title, description, icon, position });
              openDeleteAdvantageModal();
            }}
          >
            <DeleteOutlined style={{ fontSize: '20px' }} />
          </Button>
        </div>
      ),
      fixed: 'right',
    },
  ] as ColumnType<IAdvantageItemData>[];
